/* eslint no-prototype-builtins: 'error' */
/* @flow */
import 'moment/locale/en-gb';
import queryString from 'query-string';
import config from '../constants/Config';
import { getUserToken } from './utility-functions';


async function fetchDriverKeyFob(urlConfig: any) {
    const options = {
        method: 'get',
        headers: {
            'X-Nspire-UserToken': getUserToken(),
            'Content-Type': 'application/json',
        },
    };

    const baseUrl = `${config.get('PLATFORM_API_BASE_URL')}/keyFobs?assigned=false`;
    let offset = 0;
    const allData = [];
    let total = 0;
    let hasMore = true;

    while (hasMore) {
        const randVal = Date.now();
        const params = {
            ...urlConfig,
            offset,
        };

        const url = `${baseUrl}&_dc=${randVal}&${queryString.stringify(params)}`;
        const response = await fetch(url, options); // eslint-disable-line no-await-in-loop
        const data = await response.json(); // eslint-disable-line no-await-in-loop

        if (!data.content || data.content.length === 0) {
            break;
        }

        allData.push(...data.content);
        total = data.total;

        if (allData.length >= total) {
            hasMore = false;
        } else {
            offset += urlConfig.limit;
        }
    }

    return { content: allData };
}

export default fetchDriverKeyFob;
